import { useCallback, useContext, useState } from 'react';

import { CreativeFormatCreativeTypeKey, File as UploadedFile } from '../../../../../graphql/generated/graphql';
import { OnUploadProgress } from '../../../../../service/persistent/FileUploader';
import { context as DependencyContext } from '../../../../context/dependency';

export const useUploadCreative = (creativeTypeKey: CreativeFormatCreativeTypeKey) => {
  const dependency = useContext(DependencyContext);

  const [uploading, setUploading] = useState(0);
  const [uploadedFile, setUploadedFile] = useState<UploadedFile>();
  const upload = useCallback(
    async (file: File | null, onUploadProgress?: OnUploadProgress) => {
      if (file == null) {
        setUploadedFile(undefined);
        return;
      }
      try {
        setUploading((uploading) => ++uploading);
        const fileTypeRegExp =
          creativeTypeKey === CreativeFormatCreativeTypeKey.Video
            ? /^(video\/(mp4|mpeg)|audio\/(wav|x-wav|flac|mpeg|aac|x-hx-aac-adts))/
            : /^image\/(png|jpeg|gif)/;
        if (!file.type.match(fileTypeRegExp)) {
          throw new Error(`message.file_format_not_confirm`);
        }

        const _uploadedFile: UploadedFile = await dependency.fileUploader.upload(file, onUploadProgress);
        // テスト時にはuploadedFileがundefinedでスルー
        if (_uploadedFile) {
          if (_uploadedFile.mimeType.match(/^(video|image)/)) {
            if (!_uploadedFile.attribute.aspectRatio) {
              throw new Error(`message.file_format_not_confirm`);
            }
          } else if (_uploadedFile.mimeType.startsWith('audio')) {
            if (!_uploadedFile.attribute.volume) {
              throw new Error(`message.file_format_not_confirm`);
            }
          }
        }
        setUploadedFile(_uploadedFile);
      } catch (err) {
        dependency.errorPresenter.showAsNonFatal(err);
      } finally {
        setUploading((uploading) => --uploading);
      }
    },
    [dependency, creativeTypeKey],
  );

  return { upload, uploadedFile, uploading: uploading > 0 };
};
